import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './blog.css';
import { Navbar, Header, Footer } from '../../components';

// Import images for blog posts
import arImage from '../../assets/ar-sustainability.jpg';
import roboticsImage from '../../assets/robotics-sustainability.jpg';
import sdgImage from '../../assets/sdg-technology.jpg';
import aiTwinImage from '../../assets/aiTwinImage.png';

const Blog = () => {
  const posts = [
    {
      id: 1,
      title: "10 Ways XR is Revolutionizing Sustainability",
      content: "Extended Reality is paving the way for sustainable solutions...",
      image: arImage,
    },
    {
      id: 2,
      title: "AI in Robotics: Driving Sustainable Innovation",
      content: "Artificial intelligence in robotics is transforming industries...",
      image: roboticsImage,
    },
    {
      id: 3,
      title: "How AI and Digital Twins Are Turning Cities into Executable Systems",
      content: "Most discussions about Artificial Intelligence focus on prediction, automation, or data. But a quieter transformation is happening:",
      image: aiTwinImage,
    },
    {
      id: 4,
      title: "Achieving SDGs with Emerging Technologies",
      content: "The United Nations' SDGs are becoming achievable with tech...",
      image: sdgImage,
    },
    // Add more posts here as needed
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const postsPerPage = 12;

  // Filter and paginate posts
  const filteredPosts = posts.filter(post =>
    post.title.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      <Navbar />
      <Header />
      <div className="blog-container">
        <h1 className="text-center text-3xl font-bold text-white">Blog</h1>
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search blog posts..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="blog-posts">
          {currentPosts.map(post => (
            <div key={post.id} className="blog-card">
              <img src={post.image} alt={post.title} className="blog-image" />
              <h3>{post.title}</h3>
              <p>{post.content.substring(0, 100)}...</p>
              <Link to={`/blog/${post.id}`} className="btn btn-primary">
                Read More
              </Link>
            </div>
          ))}
        </div>
        {/* Pagination */}
        <div className="pagination">
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              className={`page-button ${currentPage === index + 1 ? "active" : ""}`}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Blog;
